import { render, staticRenderFns } from "./UserBannedChatMessage.htm?vue&type=template&id=2e1e222e&scoped=true&"
import script from "./UserBannedChatMessage.ts?vue&type=script&lang=js&"
export * from "./UserBannedChatMessage.ts?vue&type=script&lang=js&"
import style0 from "./UserBannedChatMessage.scss?vue&type=style&index=0&id=2e1e222e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1e222e",
  null
  
)

export default component.exports